import script from "./SendEmailDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendEmailDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./SendEmailDrawer.vue?vue&type=style&index=0&id=4425ab14&lang=scss"

const __exports__ = script;

export default __exports__